const API_KEY = 'MzExZmQyMmItNzJlOS00MjAwLWI2ZjgtMTkwNGYwODIxMDNm';

// TODO THIS API NEEDS TO BE REMOVED FROM FRONT END!!!!

export const getClockifyClients = async () => {
  const WORKSPACE_ID = '605252757060744f0803ff3c';
  const PAGE_SIZE = 100;
  let page = 1;
  let allClients = [];
  let hasMore = true;

  while (hasMore) {
    const response = await fetch(
      `https://api.clockify.me/api/v1/workspaces/${WORKSPACE_ID}/clients?page=${page}&page-size=${PAGE_SIZE}`,
      {
        method: 'GET',
        headers: {
          'X-Api-Key': API_KEY,
        },
      }
    );

    if (!response.ok) {
      console.error(`Error fetching clients: ${response.statusText}`);
      break;
    }

    const clients = await response.json();
    allClients = allClients.concat(clients);

    if (clients.length < PAGE_SIZE) {
      hasMore = false;
    } else {
      page += 1;
    }
  }
  return allClients;
};

export const getClockifyClientsOld = async () => {
  var myHeaders = new Headers();
  myHeaders.append("X-Api-Key", API_KEY);

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return await fetch('https://api.clockify.me/api/v1/workspaces/605252757060744f0803ff3c/clients', requestOptions)
    .then(response => response.json())
    .then(result => result)
    .catch(error => console.error('error', error));
}

export const getClockifyProjects = async () => {
  var myHeaders = new Headers();
  myHeaders.append("X-Api-Key", API_KEY);

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return await fetch('https://api.clockify.me/api/v1/workspaces/605252757060744f0803ff3c/projects', requestOptions)
    .then(response => response.json())
    .then(result => result)
    .catch(error => console.error('error', error));
}
